import { tx } from './i18n';
export const OFFLINE_DB_NAME = 'hamlogger_offline';

// ── Wspoldzielone stale i funkcje pomocnicze ─────────────────────────────────
// Wydzielone z App.js/Maps.js podczas refaktoru. NEUTRALNY modul: nie importuje
// niczego z App.js ani Maps.js, dzieki czemu moga z niego korzystac WSZYSTKIE
// moduly bez ryzyka CYKLICZNYCH IMPORTOW (App -> Maps -> App).
//
// To wlasnie brak tego modulu spowodowal seri ReferenceError po refaktorze:
// komponenty przeniesione do nowych plikow nadal odwolywaly sie do stalych,
// ktore zostaly w App.js -- a JS nie sprawdza tego przy kompilacji.

export const BAND_CONDS = [
  {key:'80m-40m_day',label:tx('80/40m D')},{key:'80m-40m_night',label:tx('80/40m N')},
  {key:'30m-20m_day',label:tx('20m D')},{key:'30m-20m_night',label:tx('20m N')},
  {key:'17m-15m_day',label:tx('15m D')},{key:'12m-10m_day',label:tx('10m D')},
];

export const COND_COLOR = {Good:'#00e5a0',Fair:'#ffbb00',Poor:'#ff4444'};

export const MODES = ['SSB','CW','FT8','FT4','RTTY','PSK31','AM','FM','DSTAR','C4FM','DMR','SSTV','JT65','JT9','WSPR','JS8','MSK144','OLIVIA'];
export const BANDS = ['160m','80m','60m','40m','30m','20m','17m','15m','12m','10m','6m','2m','70cm'];
const RST_DEFAULTS = { CW:'599', FT8:'-10', FT4:'-10', JT65:'-10', JT9:'-10', WSPR:'-20', MSK144:'-10', JS8:'-10' };
export const MODE_COLORS = {
  FT8:'#00e5a0',FT4:'#00c87a',JS8:'#50c878',JT65:'#64b4ff',JT9:'#5090ff',
  WSPR:'#bb88ff',MSK144:'#ffc800',OLIVIA:'#ff9632',SSB:'#00b8ff',CW:'#ffdc00',
  AM:'#ff7800',FM:'#ff5050',RTTY:'#c864ff',PSK31:'#b464ff',SSTV:'#ffb400',
  DSTAR:'#00dcff',C4FM:'#00b4ff',DMR:'#6c5ce7',
  // Tryby przemiennikow z linkiem (FM-LINK i pokrewne) -- odcienie zolto-zielone
  FMLINK:'#7ac84b',ECHOLINK:'#4bc8a0',MINILINK:'#a0c84b',EXTREMELINK:'#c8a04b',
  FMPOLAND:'#ff7a50',TETRA:'#8c5cff',
};

export const WEATHER_ICONS = {
  0:'☀️',1:'🌤️',2:'⛅',3:'☁️',45:'🌫️',48:'🌫️',
  51:'🌦️',53:'🌦️',55:'🌧️',56:'🌧️',57:'🌧️',
  61:'🌧️',63:'🌧️',65:'🌧️',66:'🌧️',67:'🌧️',
  71:'🌨️',73:'🌨️',75:'❄️',77:'🌨️',
  80:'🌦️',81:'🌧️',82:'⛈️',85:'🌨️',86:'🌨️',
  95:'⛈️',96:'⛈️',99:'⛈️',
};

export const WEATHER_DESC_PL = {
  0:tx('Bezchmurnie'),1:tx('Prawie bezchmurnie'),2:tx('Czesciowe zachmurzenie'),3:tx('Pochmurno'),
  45:tx('Mgla'),48:tx('Mgla osadzajaca szadz'),
  51:tx('Mzawka slaba'),53:tx('Mzawka'),55:tx('Mzawka intensywna'),
  56:tx('Mzawka marznaca'),57:tx('Mzawka marznaca intensywna'),
  61:tx('Deszcz slaby'),63:tx('Deszcz'),65:tx('Deszcz intensywny'),
  66:tx('Deszcz marznacy'),67:tx('Deszcz marznacy intensywny'),
  71:tx('Snieg slaby'),73:tx('Snieg'),75:tx('Snieg intensywny'),77:tx('Granulki sniegu'),
  80:tx('Przelotny deszcz slaby'),81:tx('Przelotny deszcz'),82:tx('Przelotny deszcz gwaltowny'),
  85:tx('Przelotny snieg slaby'),86:tx('Przelotny snieg intensywny'),
  95:tx('Burza'),96:tx('Burza z gradem (slaby)'),99:tx('Burza z gradem (silny)'),
};

export function nowUTC() {
  return new Date().toISOString().slice(0,16);
}

export function getRst(mode) { return RST_DEFAULTS[mode] || '59'; }

// ── Wykrywanie urzadzenia mobilnego ───────────────────────────────────────────
// Uzywamy szerokosci viewportu (matchMedia), NIE parsowania navigator.userAgent.
// Powod: stringi User-Agent sa zawodne -- latwo je podrobic, czesto nie
// odzwierciedlaja realnego rozmiaru ekranu (np. tablet w trybie desktopowym,
// przegladarka na malym oknie na komputerze), i przegladarki regularnie
// zmieniaja format UA (Chrome od pewnego czasu "zamraza" wiele szczegolow
// UA z powodow prywatnosci). Viewport-width to dokladnie to, co faktycznie
// determinuje czy dany layout sie "miesci" -- i automatycznie reaguje na
// obrot ekranu / zmiane rozmiaru okna, co UA-sniffing nigdy nie zrobi.
// Tryb uproszczony (ustawienia konta): tylko to, co niezbedne do prowadzenia logu
export const SIMPLE_VIEWS = ['logger', 'logbook', 'swl', 'stats', 'upload', 'trash', 'admin'];

export function NAV_GROUPS(userProfile, isOnline = true, t = (k)=>k) {
  if (userProfile?.simple_mode) {
    return [
      ...(userProfile?.is_swl ? [{type:'single', id:'swl', label:t('nav.swl')}] : []),
      {type:'single', id:'logger', label:t('nav.logger')},
      {type:'single', id:'logbook', label:t('nav.logbook')},
      {type:'single', id:'stats', label:t('nav.stats')},
      {type:'single', id:'upload', label:t('nav.upload')},
      ...(userProfile?.is_moderator?[{type:'single', id:'admin',
        label: userProfile?.is_admin?t('nav.admin'):t('nav.moderation')}]:[]),
    ];
  }
  return [
    {type:'single', id:'dashboard', label:t('nav.dashboard')},
    // Konto nasluchowca: dziennik nasluchow na samej gorze, logger nizej
    ...(userProfile?.is_swl ? [{type:'single', id:'swl', label:t('nav.swl')}] : []),
    {type:'single', id:'logger', label:t('nav.logger')},
    // Log: same wpisy -- lacznosci, nasluchy, kosz.
    {type:'group', key:'nav.journal', label:t('nav.journal'), items:[
      ['logbook',t('nav.logbook')],...(userProfile?.is_swl ? [] : [['portable',t('nav.portable')]]),
      ...(userProfile?.is_swl ? [] : [['swl',t('nav.swl')]]),['trash',t('nav.trash')],
    ]},
    // Wyniki: wszystko, co wynika z logu -- statystyki, mapy, dyplomy.
    {type:'group', key:'nav.results', label:t('nav.results'), items:[
      ['stats',t('nav.stats')],['analysis',t('nav.analysis')],['mypropagation',t('nav.mypropagation')],
      ['map',t('nav.qsomap')],['dxccmap',t('nav.dxccmap')],['dxcc-matrix',t('nav.dxccmatrix')],
      ['azimuthal',t('nav.azimuthal')],['diplomas',t('nav.diplomas')],['goals',t('nav.goals')],
      ['year',t('nav.year')],
    ]},
    // QSL: potwierdzenia -- wysylka do serwisow, karta eQSL, papierowe.
    {type:'group', key:'nav.qsl', label:t('nav.qsl'), items:[
      ['upload',t('nav.upload')],['eqsl',t('nav.eqsl')],['qsl',t('nav.qslpaper')],
    ]},
    // Na zywo: to, co dzieje sie teraz w eterze. Wymaga sieci.
    ...(isOnline ? [{type:'group', key:'nav.live', label:t('nav.live'), items:[
      ['cluster',t('nav.cluster')],['bandmap',t('nav.bandmap')],['dxneeded',t('nav.dxneeded')],['watchlist',t('nav.watchlist')],
      ['pota',t('nav.pota')],['wwff',t('nav.wwff')],['pskreporter',t('nav.pskreporter')],
      ['websdr',t('nav.websdr')],['svxlink',t('nav.svxlink')],['beacons',t('nav.beacons')],['alert-rules',t('nav.alertrules')],
      // Funkcje testowe -- widoczne tylko gdy flaga wlaczona (patrz tez 'tools' nizej).
      ...(userProfile?.feature_flags?.live_roster ? [['live-roster',t('nav.liveroster')]] : []),
      ...(userProfile?.feature_flags?.wsjtx_remote ? [['wsjtx-remote',t('nav.wsjtx')]] : []),
      ...(userProfile?.feature_flags?.propagation_dashboard ? [['propagation',t('nav.propagation')]] : []),
      ...(userProfile?.feature_flags?.aprs_lookup ? [['aprs',t('nav.aprs')]] : []),
    ]}] : []),
    // Plan: co i kiedy -- umowione lacznosci, przeloty, pogoda, kalendarze.
    // Skedy dzialaja tez offline (wlasne dane); reszta wymaga sieci.
    {type:'group', key:'nav.plan', label:t('nav.plan'), items:[
      ['skeds',t('nav.skeds')],
      ...(isOnline ? [['satellites',t('nav.satellites')],['weather',t('nav.weather')]] : []),
      ...(isOnline && userProfile?.feature_flags?.activation_planner ? [['activation-planner',t('nav.activationplanner')]] : []),
      ...(isOnline ? [['contests',t('nav.contests')],['dxpeditions',t('nav.dxpeditions')]] : []),
    ]},
    // Info: zagregowane tresci z zewnetrznych zrodel. Wymaga sieci.
    ...(isOnline ? [{type:'group', key:'nav.info', label:t('nav.info'), items:[
      ['news',t('nav.news')],['mostwanted',t('nav.mostwanted')],
    ]}] : []),
    {type:'group', key:'nav.community', label:t('nav.community'), items:[
      ['neighbors',t('nav.neighbors')],['nets',t('nav.nets')],['klub',t('nav.shared')],
      ...(isOnline ? [['chat',t('nav.chat')],['market',t('nav.market')]] : []),['ranking',t('nav.ranking')],
    ]},
    {type:'group', key:'nav.tools', label:t('nav.tools'), items:[
      ['station',t('nav.station')],['antenna',t('nav.antenna')],['keyer',t('nav.keyer')],['exam',t('nav.exam')],
      ['agent-diag',t('nav.agentdiag')],
      // Funkcje w fazie testow -- widoczne tylko gdy flaga wlaczona.
      ...(userProfile?.feature_flags?.cw_decoder ? [['cw-decoder',t('nav.cwdecoder')]] : []),
      ...(userProfile?.feature_flags?.cw_trainer ? [['cw-trainer',t('nav.cwtrainer')]] : []),
      ...(userProfile?.feature_flags?.path_calculator ? [['path-calc',t('nav.pathcalc')]] : []),
      ...(userProfile?.feature_flags?.qso_rate_meter ? [['qso-rate',t('nav.qsorate')]] : []),
    ]},
    ...(userProfile?.is_moderator?[{type:'single', id:'admin',
      label: userProfile?.is_admin?t('nav.admin'):t('nav.moderation')}]:[]),
  ];
}

export function parseFreq(value) {
  if (value === null || value === undefined) return NaN;
  if (typeof value === 'number') return value;
  return parseFloat(String(value).replace(',', '.').trim());
}

export function calculateSolarPosition(date) {
  const rad = Math.PI / 180;
  const start = new Date(Date.UTC(date.getUTCFullYear(), 0, 0));
  const dayOfYear = Math.floor((date - start) / 86400000);
  const declination = -23.44 * Math.cos(rad * (360 / 365) * (dayOfYear + 10));
  const utcHours = date.getUTCHours() + date.getUTCMinutes() / 60 + date.getUTCSeconds() / 3600;
  const subsolarLon = -(utcHours - 12) * 15; // stopnie
  return { declination, subsolarLon };
}

export function solarElevation(lat, lon, declination, subsolarLon) {
  const rad = Math.PI / 180;
  const hourAngle = (lon - subsolarLon) * rad;
  const latR = lat * rad, decR = declination * rad;
  const sinElev = Math.sin(latR) * Math.sin(decR) + Math.cos(latR) * Math.cos(decR) * Math.cos(hourAngle);
  return Math.asin(Math.max(-1, Math.min(1, sinElev))) / rad; // stopnie
}

export async function getQueuedQsos() {
  const db = await openOfflineDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(OFFLINE_STORE, 'readonly');
    const req = tx.objectStore(OFFLINE_STORE).getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function removeQueuedQso(localId) {
  const db = await openOfflineDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(OFFLINE_STORE, 'readwrite');
    tx.objectStore(OFFLINE_STORE).delete(localId);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function updateQueuedQsoError(localId, errorMsg) {
  const db = await openOfflineDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(OFFLINE_STORE, 'readwrite');
    const store = tx.objectStore(OFFLINE_STORE);
    const getReq = store.get(localId);
    getReq.onsuccess = () => {
      const item = getReq.result;
      if (item) { item.lastError = errorMsg; store.put(item); }
    };
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}


export const OFFLINE_STORE = 'pending_qsos';

// Zapis QSO do kolejki offline (IndexedDB) -- wspolne dla formularza loggera
// i trybu portable. Po zapisie: zdarzenie hamlogger:offline-queued (licznik).
export async function queueOfflineQsoShared(qsoData) {
  const db = await openOfflineDB();
  await new Promise((resolve, reject) => {
    const t = db.transaction(OFFLINE_STORE, 'readwrite');
    t.objectStore(OFFLINE_STORE).add({ ...qsoData, queuedAt: new Date().toISOString() });
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
  try { window.dispatchEvent(new CustomEvent('hamlogger:offline-queued')); } catch { /* brak window */ }
}

export function openOfflineDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(OFFLINE_DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(OFFLINE_STORE)) {
        db.createObjectStore(OFFLINE_STORE, { keyPath: 'localId', autoIncrement: true });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}


// ── Bezpieczne rzutowanie na tablice ─────────────────────────────────────────
// `r.data.items || []` chroni TYLKO przed null/undefined. Gdy API zwroci obiekt,
// string albo cokolwiek innego (uszkodzony rekord w bazie, zmiana formatu,
// blad serwera zwracajacy {error:...}), kod robi potem `.filter()` / `.map()`
// na nie-tablicy i CALA APLIKACJA sie wywala z bialym ekranem.
//
// Realny przypadek: uszkodzony wpis ulubionych czestotliwosci wywalal cala
// aplikacje przy starcie ("c.filter is not a function").
export function asArray(v) {
  return Array.isArray(v) ? v : [];
}
